// src/pages/Login.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8081";

const Login = () => {
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [telefone, setTelefone] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); setMessage("");
    try {
      const { data } = await axios.post(`${API_BASE_URL}/api/auth/login`, { login, senha });
      localStorage.setItem("authToken", data.token);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || "Erro ao realizar login. Tente novamente.");
    }
  };

  const handleForgotPassword = async () => {
    setError(""); setMessage("");
    try {
      const { data } = await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { phone: telefone });
      setMessage(`ID do usuário: ${data.userId}. Contate o administrador.`);
    } catch (err) {
      setError(err.response?.data?.error || "Erro ao buscar usuário. Verifique o telefone.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo">
          <picture>
            <source srcSet="https://drphlopes.com.br/arquivos/logofutebotcalro.png" media="(min-width: 768px)" />
            <img src="https://drphlopes.com.br/arquivos/FUTEBOTfundoescuro.png" alt="Logo Futebot" />
          </picture>
        </div>
        <h1>Login</h1>

        {showForgotPassword ? (
          <>
            <div className="form-group">
              <label htmlFor="telefone">Telefone:</label>
              <input
                type="text"
                id="telefone"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
                placeholder="(32) 9 9999-9999"
              />
            </div>
            {message && <p className="success-message">{message}</p>}
            {error && <p className="error-message">{error}</p>}
            <button onClick={handleForgotPassword}>Recuperar ID</button>
            <button onClick={() => setShowForgotPassword(false)}>Voltar</button>
          </>
        ) : (
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="login">Login:</label>
              <input
                type="text"
                id="login"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="senha">Senha:</label>
              <input
                type="password"
                id="senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>
            {error && <p className="error-message">{error}</p>}
            <button type="submit">Entrar</button>
            <button type="button" onClick={() => setShowForgotPassword(true)}>
              Esqueci minha senha
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;
